// ProjectContributorList.jsx
import React from 'react';
import ProjectContributorCard from './ProjectContributorCard';

const ProjectContributorList = ({ users = [] }) => (
  <div className="contributors-row">
    {users.map((userId) => (
      <ProjectContributorCard key={userId} user_id={userId} />
    ))}
  </div>
);

export default ProjectContributorList;